import { render, staticRenderFns } from "./CheckerboardSizeSelector.vue?vue&type=template&id=08a3ba43"
import script from "./CheckerboardSizeSelector.vue?vue&type=script&lang=js"
export * from "./CheckerboardSizeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports